$(".single-slider .slide-list").slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
});

$(".featured_collection_sc .products").slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".reviewBox").slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

document.addEventListener(
  "DOMContentLoaded",
  function () {
    $("ul.tabs").each(function () {
      var active,
        content,
        links = $(this).find("a");
      active = links.first().addClass("active");
      content = $(active.attr("href"));
      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });
      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");
          content.hide();
          active = $(this);
          content = $($(this).attr("href"));
          active.addClass("active");
          content.show();
          return false;
        });
    });
  },
  false
);

$(".search-field").on("input", function () {
  console.log($(this).val());
  if ($(this).val().length > 0) {
    $(".close").show();
  } else {
    $(".close").hide();
  }
});
$(".close").click(function () {
  $(".search-field").val("");
  $(this).hide();
  $("#shopify-section-predictive-search").hide();
});

$(document).on("click", ".thb-close", function() {
   $('.click-capture').trigger('click');
});
